import styles from "@/components/time.module.css";
import * as signals from "@/signals";
import { handleKeyboardClick, toggleSecondaryScreen } from "@/utils";
import { useSignalEffect } from "@preact/signals";
import clsx from "clsx";
import { JSX, useEffect, useState } from "react";

function Time(): JSX.Element {
	const [time, setTime] = useState({
		hours: "00",
		minutes: "00",
		seconds: "00",
	});
	const [isTwinkleAnimationReady, setIsTwinkleAnimationReady] =
		useState(true);

	const isFolderNameShown =
		signals.currentFolder.value && signals.isSecondaryScreenShown.value;

	const handleTimeClick = (): void => {
		void toggleSecondaryScreen();
	};

	useEffect(() => {
		if (isFolderNameShown) {
			return;
		}

		const updateTime = (): void => {
			const now = new Date();
			const minutes = now.getMinutes();
			const seconds = now.getSeconds();
			let hours = now.getHours();
			if (!signals.generalSettings.value.is24HourTime) {
				hours = hours % 12;
				if (hours === 0) {
					hours = 12;
				}
			}
			setTime({
				hours: signals.generalSettings.value.is24HourTime
					? hours.toString().padStart(2, "0")
					: hours.toString(),
				minutes: minutes.toString().padStart(2, "0"),
				seconds: seconds.toString().padStart(2, "0"),
			});
		};

		const interval = setInterval(updateTime, 1000);
		updateTime();

		return (): void => {
			clearInterval(interval);
		};
	}, [isFolderNameShown]);

	// Reset twinkle animation to avoid asynchronous animations on two time separators
	useSignalEffect(() => {
		if (!signals.generalSettings.value.shouldShowSeconds) {
			return;
		}
		setIsTwinkleAnimationReady(false);
		setTimeout(() => {
			setIsTwinkleAnimationReady(true);
		}, 50);
	});

	return (
		<div
			className={clsx(
				"fade-in",
				styles["time"],
				signals.isSearchFocused.value && styles["search-focused"],
				signals.generalSettings.value.timeFontWeight === "light" &&
					styles["light"],
				!!signals.currentFolder.value && styles["folder-name"],
			)}
			onClick={handleTimeClick}
			onKeyDown={handleKeyboardClick(handleTimeClick)}
			role="button"
			tabIndex={0}
		>
			{isFolderNameShown ? (
				signals.currentFolder.value?.folderName
			) : (
				<>
					{time.hours}
					<span
						className={clsx(
							signals.generalSettings.value.shouldTimeTwinkle &&
								isTwinkleAnimationReady &&
								"twinkle",
						)}
					>
						:
					</span>
					{time.minutes}
					{signals.generalSettings.value.shouldShowSeconds && (
						<>
							<span
								className={clsx(
									signals.generalSettings.value
										.shouldTimeTwinkle &&
										isTwinkleAnimationReady &&
										"twinkle",
								)}
							>
								:
							</span>
							{time.seconds}
						</>
					)}
				</>
			)}
		</div>
	);
}

export default Time;
